// @ts-nocheck

import React, { useState, useEffect, useMemo, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector, RootStateOrAny } from 'react-redux'
import Select from 'react-select'
import { useMediaQuery } from 'react-responsive'

import { Mobile, Desktop } from 'Shared/components/Responsive'
import { getAllLanguages } from 'Redux/actions/languagesActions'
import closeIcon from 'Shared/icons/close-cross-white.svg'
import { GreyBtn, GreyBtnDisabledWide } from 'Stories/Button/Button.stories'
import { IconCheckMark } from 'Stories/Icon/Icon.stories'
import GreyCheckmark from 'Shared/icons/checkmark-grey-round.svg'
import GreenCheckmark from 'Shared/icons/checkmark-green-round.svg'
import ArrowLeftIcon from 'Shared/icons/arrow-left.svg'
import { customStyles } from 'Shared/components/CustomStyles'
import { editPlaylistsLanguages } from 'Redux/actions/playListsActions'
import { markLangModalAsShown } from 'Redux/actions/sessionNotificationsActions'

import {
  ActionsForSelectGenresAndLanguagesEnum,
  Playlist,
} from '../../../../Types'
import { ModalComponentProps } from './props'
import * as S from './styles'

const ModalComponent: React.FunctionComponent<ModalComponentProps> = ({
  setMobileContentModal,
  setModalValue,
  toggle,
  modal,
  pageTitle,
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const isMobile = useMediaQuery({ maxWidth: 576 })
  const languageModalShown: boolean = useSelector(
    (state: RootStateOrAny) => state.sessionNotifications.languageModalShown
  )

  useEffect(() => {
    dispatch(getAllLanguages())
  }, [])

  const allPlaylists = useSelector(
    (state: RootStateOrAny) => state.playlists.playlists
  )
  const languages = useSelector(
    (state: RootStateOrAny) => state.languages.languages
  )
  const languagesFiltered = languages.filter(el => el.id !== 1)
  const languagesSorted = useMemo(() => {
    const elementsToMove = languagesFiltered.filter(
      el => el.id === 2 || el.id === 3
    )
    const elementsRest = languagesFiltered.filter(
      el => el.id !== 2 && el.id !== 3
    )
    return [...elementsToMove, ...elementsRest]
  }, [languagesFiltered])

  const [selectedInputLanguages, setSelectedLanguages] = useState([])
  const [selectedStyleLanguagesId, setSelectedStyleLanguagesId] = useState(null)
  const [inputValueLanguages, setTnputValueLanguages] = useState([])
  const [checkedNoPrefs, setCheckedNoPrefs] = useState([])

  const playlistsWithNoPref = useMemo(() => {
    if (allPlaylists) {
      return allPlaylists.filter(
        el =>
          el.meets_conditions &&
          (el.PlaylistLanguages.length === 0 ||
            (el.PlaylistLanguages[0].language_id === 1 &&
              el.PlaylistLanguages.length === 1))
      )
    }
    return []
  }, [allPlaylists])

  useEffect(() => {
    if (playlistsWithNoPref.length) {
      const emptyState = [[], [], []]
      for (let i = 0; i < playlistsWithNoPref.length; i += 1) {
        emptyState[0].push([])
        emptyState[1].push('')
        emptyState[2].push(true)
      }
      setSelectedLanguages(emptyState[0])
      setTnputValueLanguages(emptyState[1])
      setCheckedNoPrefs(emptyState[2])
      if (!languageModalShown) {
        if (isMobile) {
          setMobileContentModal(true)
        }
        dispatch(markLangModalAsShown())
        setModalValue(true)
      }
    }
  }, [playlistsWithNoPref, languageModalShown])

  const optionsSelectLanguages = options => {
    if (options === undefined) return []

    const languagesOptions = options.map(item => ({
      value: item.id,
      label:
        item.language_name.slice(0, 1).toUpperCase() +
        item.language_name.slice(1),
    }))
    return [...languagesOptions]
  }

  const formatOptionLabelLanguages = (
    { label, value },
    { inputValue, selectValue },
    id
  ) => {
    const inputLength = inputValue.length

    const index = label.toLowerCase().indexOf(inputValue.toLowerCase())
    const selectValueLabel = selectValue.map(item => item.label)

    if (selectValueLabel.includes(label)) {
      return <div>{label}</div>
    }

    if (selectedStyleLanguagesId === value) {
      return (
        <S.LanguagesSelectItemAnimation>
          <S.IconCheckMarkWrapper>
            <IconCheckMark />
          </S.IconCheckMarkWrapper>

          <span>
            {label.slice(0, index)}
            <strong>
              {index === 0
                ? inputValueLanguages[id].slice(0, 1).toUpperCase() +
                  inputValueLanguages[id].slice(1)
                : inputValueLanguages[id]}
            </strong>
            {label.slice(index + inputLength)}
          </span>
          <span />
        </S.LanguagesSelectItemAnimation>
      )
    }

    return (
      <S.LanguagesSelectItem>
        <span>
          {label.slice(0, index)}
          <strong style={index === 0 ? { textTransform: 'capitalize' } : null}>
            {inputValueLanguages}
          </strong>
          {label.slice(index + inputLength)}
        </span>
        <span />
      </S.LanguagesSelectItem>
    )
  }

  const handleInputChangeLanguages = (characterEntered, id) => {
    setTnputValueLanguages(
      inputValueLanguages.map((el, index) =>
        index === id ? characterEntered : el
      )
    )
  }

  const onChangeSelectLanguages = (selectedOptions, { action, option }, id) => {
    setTnputValueLanguages(inputValueLanguages)

    if (action === ActionsForSelectGenresAndLanguagesEnum.SELECT_OPTION) {
      if (option.value === 1) {
        return setSelectedLanguages(
          selectedInputLanguages.map((el, index) =>
            index === id ? [option] : el
          )
        )
      }

      const selectedOptionsWithoutNoVocal = selectedOptions.filter(
        lang => lang.value !== 1
      )

      setSelectedStyleLanguagesId(option.value)

      setTimeout(() => {
        setSelectedLanguages(
          selectedInputLanguages.map((el, index) =>
            index === id ? selectedOptionsWithoutNoVocal : el
          )
        )
        setSelectedStyleLanguagesId(null)
      }, 500)
    } else {
      setSelectedLanguages(
        selectedInputLanguages.map((el, index) =>
          index === id ? selectedOptions : el
        )
      )
    }
    return null
  }

  const renderPlaylist = (item: Playlist, id: number) => (
    <S.PlaylistContainer>
      <S.PlaylistTopContainer>
        <S.PlaylistCover src={item.playlist_cover} alt="" />
        <S.PlaylistInfo>
          <S.PlaylistName>
            {item.playlist_name.length > 45
              ? item.playlist_name.substring(0, 45).concat('...')
              : item.playlist_name}
          </S.PlaylistName>
          <S.PlaylistScore>
            {t('playlistsPage.score')}:
            <S.PlaylistScoreNumber>
              {` ${item.score + item.extra_score}`}
            </S.PlaylistScoreNumber>
          </S.PlaylistScore>
        </S.PlaylistInfo>
        {selectedInputLanguages[id] && !!selectedInputLanguages[id].length ? (
          <S.CheckMark src={GreenCheckmark} alt="" />
        ) : (
          <S.CheckMark src={GreyCheckmark} alt="" />
        )}
      </S.PlaylistTopContainer>
      <S.SelectWrapper>
        <div className="targetLanguage-title">
          <div>{t('targetLanguages.targetLanguage')}</div>
        </div>
        <div>
          <Select
            isMulti
            menuShouldBlockScroll
            styles={customStyles}
            menuPlacement="auto"
            menuPosition="fixed"
            placeholder={t('createCampaignPage.startTypingLanguageName')}
            classNamePrefix="multi-select"
            closeMenuOnSelect={false}
            options={optionsSelectLanguages(languagesSorted)}
            value={selectedInputLanguages[id]}
            inputValue={inputValueLanguages[id]}
            components={{ DropdownIndicator: null }}
            formatOptionLabel={(label, inputValue) =>
              formatOptionLabelLanguages(label, inputValue, id)
            }
            onInputChange={value => handleInputChangeLanguages(value, id)}
            onChange={(option, value) =>
              onChangeSelectLanguages(option, value, id)
            }
          />
        </div>
      </S.SelectWrapper>
    </S.PlaylistContainer>
  )

  const onSubmit = useCallback(() => {
    const result = selectedInputLanguages.map((el, id) => {
      if (el.length) {
        const language_ids = el.map(el => el.value)
        if (!checkedNoPrefs[id]) {
          language_ids.push(1)
        }
        return {
          id: playlistsWithNoPref[id].id,
          genre_ids: playlistsWithNoPref[id].PlaylistGenres.map(
            el => el.genre_id
          ),
          language_ids,
          moods_ids: playlistsWithNoPref[id].PlaylistMoods.map(
            el => el.mood_id
          ),
        }
      }
      return null
    })

    dispatch(editPlaylistsLanguages(result.filter(el => el)))
    toggle()
  }, [playlistsWithNoPref, selectedInputLanguages, checkedNoPrefs])

  const submitEnabled = useMemo(
    () => selectedInputLanguages.find(el => el.length),
    [selectedInputLanguages]
  )

  const Button = isMobile ? GreyBtnDisabledWide : GreyBtn

  return (
    <>
      <Desktop>
        <S.StyledModal
          visible={modal}
          title={t('playlistsPage.playlistsToSetModal')}
          closeIcon={<S.CloseIcon src={closeIcon} alt="clear-button" />}
          footer={null}
          onCancel={toggle}
        >
          <S.ModalContent>
            <S.ModalTitle>
              {t('playlistsPage.playlistsToSetTitle')}
            </S.ModalTitle>
            <S.ModalDescription>
              <S.ModalDescriptionText>
                {t('playlistsPage.playlistsToSetRow1')}
              </S.ModalDescriptionText>
            </S.ModalDescription>
            <S.ModalDescription>
              <S.ModalDescriptionText>
                {t('playlistsPage.playlistsToSetRow2Part1')}
              </S.ModalDescriptionText>
              <S.ModalDescriptionTextBold>
                {` ${playlistsWithNoPref.length} ${t(
                  'playlistsPage.playlistsToSetRow2Highlight'
                )} `}
              </S.ModalDescriptionTextBold>
              <S.ModalDescriptionText>
                {t('playlistsPage.playlistsToSetRow2Part2')}
              </S.ModalDescriptionText>
            </S.ModalDescription>
            {playlistsWithNoPref.map((el, id) => renderPlaylist(el, id))}
            <S.ButtonsContainer>
              {submitEnabled ? (
                <GreyBtn color="green" onClick={onSubmit}>
                  {t('playlistsPage.saveSettings')}
                </GreyBtn>
              ) : (
                <GreyBtn color="greyDisabled" disabled>
                  {t('playlistsPage.saveSettings')}
                </GreyBtn>
              )}
            </S.ButtonsContainer>
          </S.ModalContent>
        </S.StyledModal>
      </Desktop>
      <Mobile>
        {modal && (
          <>
            <S.MobilePageTitleRow>
              <S.BackButton src={ArrowLeftIcon} alt="" onClick={toggle} />
              <S.PageTitle>{pageTitle}</S.PageTitle>
            </S.MobilePageTitleRow>
            <S.MobileContainer>
              <S.ModalTitle>
                {t('playlistsPage.playlistsToSetTitle')}
              </S.ModalTitle>
              <S.ModalDescription>
                <S.ModalDescriptionText>
                  {t('playlistsPage.playlistsToSetRow1')}
                </S.ModalDescriptionText>
              </S.ModalDescription>
              <S.ModalDescription>
                <S.ModalDescriptionText>
                  {t('playlistsPage.playlistsToSetRow2Part1')}
                </S.ModalDescriptionText>
                <S.ModalDescriptionTextBold>
                  {` ${playlistsWithNoPref.length} ${t(
                    'playlistsPage.playlistsToSetRow2Highlight'
                  )} `}
                </S.ModalDescriptionTextBold>
                <S.ModalDescriptionText>
                  {t('playlistsPage.playlistsToSetRow2Part2')}
                </S.ModalDescriptionText>
              </S.ModalDescription>
              {playlistsWithNoPref.map((el, id) => renderPlaylist(el, id))}
              <S.ButtonsContainer>
                {submitEnabled ? (
                  <Button color="green" onClick={onSubmit}>
                    {t('playlistsPage.saveSettings')}
                  </Button>
                ) : (
                  <Button color="greyDisabled" disabled>
                    {t('playlistsPage.saveSettings')}
                  </Button>
                )}
              </S.ButtonsContainer>
            </S.MobileContainer>
          </>
        )}
      </Mobile>
    </>
  )
}

export default ModalComponent
